import React from 'react';
import Search from './Search';

interface BoxContentSearchHeaderProps {
    onHandleSearching?: CallableFunction;
    show?: boolean;
}

const BoxContentSearchHeader = ({onHandleSearching=() => {}, show=true}: BoxContentSearchHeaderProps) => {
    if (!show) return null;
    return (
        <div className="hidden md:flex flex-grow h-full">
            <div className="relative flex items-center w-full">
                <Search onSearching={onHandleSearching} fromBottom={false} />
            </div>
        </div>
    );
};

export default BoxContentSearchHeader;
